module.exports = __webpack_public_path__ + "static/media/Magen David Adom.f1a0feb0.png";